export default __webpack_public_path__ + "static/icon-12-5-aabf79144fdde39c417123514bad25ac.png";